// -------- AUTH ---------
export const API_AUTH_SIGN_IN = 'auth/sign-in';
export const API_AUTH_SIGN_OUT = 'auth/sign-out';
export const API_AUTH_SIGNUP = 'auth/sign-up';
export const FORGOT_PASSWORD = 'auth/forgot-password';
export const RESET_PASSWORD = 'auth/reset-password';
export const GET_TOKEN_RESET_PASSWORD = 'auth/get-token-reset-password';
export const API_AUTH_SIGN_UP_INVITE = 'auth/sign-up/:dataAccept';
export const API_AUTH_CURRENT_USER = 'auth/current-user';

// -------- SYSTEM_ADMIN --------
export const API_SYSTEM_ADMIN_GENERAL = 'general';
export const API_SYSTEM_ADMIN_FIND_DATA_PRODUCT = 'general/find-data-product';
export const API_SYSTEM_ADMIN_CE_PACKS = 'ce-pack';
export const API_SYSTEM_ADMIN_CE_PACK = 'ce-pack/:id';
export const API_SYSTEM_ADMIN_PRODUCT_TYPE = 'product-type';
export const API_SYSTEM_ADMIN_PRODUCT_TYPE_DETAIL = 'product-type/:productTypeId';
export const API_SYSTEM_ADMIN_CERTIFICATES = 'certificate';
export const API_SYSTEM_ADMIN_CERTIFICATE = 'certificate/:id';
export const API_SYSTEM_ADMIN_LICENSEES = 'licensee';
export const API_SYSTEM_ADMIN_LICENSEE = 'licensee/:id';
export const API_SYSTEM_ADMIN_TESTS = 'test';
export const API_SYSTEM_ADMIN_TEST = 'test/:id';
export const API_SYSTEM_ADMIN_DUPLICATE_TEST = 'test/duplicate';
export const API_SYSTEM_ADMIN_SEAT = 'seat/:id';
export const API_SYSTEM_ADMIN_SEAT_EVENT = 'seat/:productId/event/:eventId';

export const API_SYSTEM_ADMIN_PRODUCTS = 'products';
export const API_SYSTEM_ADMIN_PRODUCT = 'products/:id';
export const API_SYSTEM_ADMIN_GET_ALL_PRODUCTS = 'admin/products';
export const API_SYSTEM_ADMIN_GET_ALL_PRODUCTS_EVENTS_LIMIT = 'admin/products/get-all/events-limit';
export const API_SYSTEM_ADMIN_PRODUCT_DETAILS = 'admin/products/:id';
export const API_SYSTEM_ADMIN_PRODUCT_EVENTS = 'products/:id/event';
export const API_SYSTEM_ADMIN_PRODUCT_EVENT = 'products/:id/event/:eventId';
export const API_SYSTEM_ADMIN_PRODUCT_EVENT_CLONE = 'products/:id/event/:eventId/clone';
export const API_SYSTEM_ADMIN_PRODUCT_EVENT_CONFIRM_ATTENDEES = 'products/:id/event/:eventId/confirm-attendees';
export const API_SYSTEM_ADMIN_PRODUCT_MEDIAS = 'products/:id/media';
export const API_SYSTEM_ADMIN_PRODUCT_MEDIA = 'products/:id/media/:mediaId';
export const API_SYSTEM_ADMIN_PRODUCT_REVIEWS = 'products/:id/review';
export const API_SYSTEM_ADMIN_PRODUCT_REVIEW = 'products/:id/review/:reviewId';
export const API_SYSTEM_ADMIN_PRODUCT_INSTRUCTORS = 'products/:id/instructors';
export const API_SYSTEM_ADMIN_PRODUCT_INSTRUCTOR = 'products/:id/instructors/:instructorId';
export const API_SYSTEM_ADMIN_PRODUCT_INSTRUCTOR_ORDER = 'products/:id/instructor/order/:instructorId';
export const API_SYSTEM_ADMIN_PRODUCT_INSTRUCTORS_LEADER = 'products/:id/instructors-leader';
export const API_SYSTEM_ADMIN_PRODUCT_LICENSEES = 'products/:id/licensee';
export const API_SYSTEM_ADMIN_PRODUCT_LICENSEE = 'products/:id/licensee/:licenseeId';
export const API_SYSTEM_ADMIN_PRODUCT_FAQS = 'faq';
export const API_SYSTEM_ADMIN_PRODUCT_FAQ = 'faq/:id';
export const API_SYSTEM_ADMIN_PRODUCT_FAQ_ORDER_UP = 'faq/order-up/:id';
export const API_SYSTEM_ADMIN_PRODUCT_FAQ_ORDER_DOWN = 'faq/order-down/:id';
export const API_SYSTEM_ADMIN_SELLING_GROUPS = 'selling-group';
export const API_SYSTEM_ADMIN_SELLING_GROUP = 'selling-group/:id';
export const API_SYSTEM_ADMIN_SELLING_GROUP_CATEGORIES = 'selling-group-category';
export const API_SYSTEM_ADMIN_SELLING_GROUP_CATEGORY = 'selling-group-category/:id';

export const API_SYSTEM_ADMIN_LESSONS = 'lesson';
export const API_SYSTEM_ADMIN_LESSON = 'lesson/:id';
export const API_SYSTEM_ADMIN_LESSON_ORDER_UP = 'lesson/order-up/:id';
export const API_SYSTEM_ADMIN_LESSON_ORDER_DOWN = 'lesson/order-down/:id';
export const API_SYSTEM_ADMIN_QUESTIONS = 'question';
export const API_SYSTEM_ADMIN_QUESTION = 'question/:id';
export const API_SYSTEM_ADMIN_INSTRUCTORS = 'instructor';
export const API_SYSTEM_ADMIN_INSTRUCTOR = 'instructor/:id';
export const API_SYSTEM_ADMIN_ANSWERS = 'answer';
export const API_SYSTEM_ADMIN_ANSWER = 'answer/:id';
export const API_SYSTEM_ADMIN_PREREQUISITE = 'products/:productId/prerequisite';
export const API_SYSTEM_ADMIN_PREREQUISITE_ORDER = 'products/:productId/prerequisite/order/:id';
export const API_SYSTEM_ADMIN_ORDER = 'order';
export const API_SYSTEM_ADMIN_ORDER_DETAIL = 'order/:id';
export const API_SYSTEM_ADMIN_ORDER_REFUND_DETAIL = 'order/refund/:id';
export const API_SYSTEM_ADMIN_ORDER_REFUND = 'order/refund';
export const API_SYSTEM_ADMIN_ORDER_INDIVIDUAL_DETAIL = 'order/user/:id';
export const API_SYSTEM_ADMIN_PRODUCT_TYPE_DELETE_CHECKING = 'product-type/delete-checking/:id';
export const API_SYSTEM_ADMIN_SELLING_GROUP_DELETE_CHECKING = 'selling-group/delete-checking/:id';
export const API_SYSTEM_ADMIN_TEST_DELETE_CHECKING = 'test/delete-checking/:id';
export const API_SYSTEM_ADMIN_LICENSEE_DELETE_CHECKING = 'licensee/delete-checking/:id';
export const API_SYSTEM_ADMIN_PRODUCTS_DELETE_CHECKING = 'products/delete-checking/:id';
export const API_SYSTEM_ADMIN_CERTIFICATE_DELETE_CHECKING = 'certificate/delete-checking/:id';
export const API_SYSTEM_ADMIN_CE_PACK_DELETE_CHECKING = 'ce-pack/delete-checking/:id';
export const API_SYSTEM_ADMIN_PRODUCT_ACCESS = 'user/product/product-access/:userId';
export const API_SYSTEM_ADMIN_ADD_PRODUCT_ACCESS = 'user/product/create-course-admin';
export const API_SYSTEM_ADMIN_DELETE_PRODUCT_ACCESS = 'user/product/delete-course-admin/:id';
export const API_SYSTEM_ADMIN_GET_EVENTS_TO_MOVE = 'products/:productId/:userId/admin-other-events';
export const API_SYSTEM_SURVEY_REPORTS = 'survey-reports/';
export const API_SYSTEM_PREVIEW_PDF_SURVEY_REPORTS = 'survey-reports/preview-pdf/';
export const API_SYSTEM_ADMIN_PRODUCT_SEND_EMAILS = 'products/send-email/:id';

export const API_SYSTEM_ADMIN_GET_USER_ADD_SEAT = 'user/admin-get-users-add-seat/:id';
export const API_SYSTEM_ADMIN_GET_USER_FILL_SEAT = 'user/admin-get-users-fill-seat';
export const API_SYSTEM_ADMIN_GET_USERS_CREATE_ORGANIZATION = 'user/admin-get-users-create-organization';
export const API_SYSTEM_ADMIN_ADD_SEAT_EVENT = 'seat/admin-add-event-seat/:id';
export const API_SYSTEM_ADMIN_REMOVE_SEAT_EVENT = 'seat/admin-remove-event-seat/:id';
export const API_SYSTEM_ADMIN_ADD_MULTIPLE_SEAT_EVENT = 'seat/admin-add-multiple-seat/:id';
export const API_SYSTEM_ADMIN_GET_ORGANIZATION_FILL_SEAT = 'organization/admin-get-organization-fill-seat/:id';
export const API_SYSTEM_ADMIN_GET_ALL_ORGANIZATIONS_TO_ASSIGN = 'organization/:licenseeId/admin-get-organizations-assign/';
export const API_SYSTEM_ADMIN_GET_ASSIGNED_ORGANIZATIONS = 'organization/product/:eventId/admin-get-assigned-organizations/';
export const API_SYSTEM_ADMIN_DELETE_ASSIGN_ORGANIZATION = 'organization/product/:id/admin-delete-assigned-organization/';
export const API_SYSTEM_ADMIN_UPDATED_WITH_ASSIGN_ORGANIZATIONS = 'products/:id/event/:eventId/admin-update-event-with-assign-organization';
export const API_SYSTEM_ADMIN_ASSIGN_EVENT_TO_ORGANIZATION = 'products/:id/event/:eventId/assign-event-to-organization';

export const API_SYSTEM_ADMIN_GET_EVENT_USER_PRODUCTS = 'user/product/admin-get/:eventId'; //Get userProduct show in confirmAttendees
export const API_SYSTEM_ADMIN_GET_LIST_USES_COUPON = 'coupon/list-uses'; //Get List Uses Coupon show in Coupon > List Uses
export const API_SYSTEM_ADMIN_GET_LIST_USES_COUPON_EXPORT = 'coupon/export-list-user'; //Get List Uses Coupon show in Coupon > List Uses Export

export const API_SYSTEM_ADMIN_API_KEY_HUBSPOT = 'general-setting/api-key'; //Get token hubspot form
export const API_SYSTEM_ADMIN_CONNECT_HUBSPOT = 'hubspot/connect-hubspot'; //Get database general setting
export const API_SYSTEM_ADMIN_PAUSE_SYNC_HUBSPOT = 'hubspot/:id/status-sync'; //Get pause all api sync

export const API_SYSTEM_ADMIN_HUBSPOT_CONTACT_PROPERTIES = 'hubspot/contact-props'; //Get list contact properties hubspot
export const API_SYSTEM_ADMIN_UPDATE_HISTORICAL_STATUS = 'hubspot/historical-status'; // Update historical status
export const API_SYSTEM_ADMIN_GET_HISTORICAL_STATUS = 'hubspot/historical-status'; // Get historical status
export const API_SYSTEM_ADMIN_GET_MAPPING_FIELDS = 'hubspot/fields-mapper'; // Get mapping fields RP->HS
export const API_SYSTEM_ADMIN_UPDATE_MAPPING_FIELDS = 'hubspot/settings'; // Update mapping fields RP->HS
export const API_SYSTEM_ADMIN_NEW_SYNC = 'hubspot/new-sync'; // Star sync data TP->Hubspot

export const API_SYSTEM_CE_REPORTS_PREVIEW = 'ce-reports/preview/:dataFilterCeReport';
export const API_SYSTEM_CE_REPORTS_EXCEL = 'ce-reports/excel/:dataFilterCeReport';

export const API_GET_USER_PRODUCTS_EVENTS = 'user/product/event';
export const API_SYSTEM_ADMIN_BUNDLED_SEATS = 'product-bundle-seat/data-lists';

// -------- SOW-ORDER --------
export const API_SYSTEM_ADMIN_SOW_ORDER = 'order/sow-orders';
export const API_SYSTEM_ADMIN_SOW_ORDER_DETAIL = 'order/sow-orders/:id';
export const API_SYSTEM_ADMIN_SOW_ORDER_INFO = 'order/sow-orders/info/:id';
export const API_SYSTEM_ADMIN_CLOSE_SOW_ORDER = 'order/sow-orders/close/:id';
export const API_SYSTEM_ADMIN_ATTACHMENT = 'attachment';
export const API_SYSTEM_ADMIN_ATTACHMENT_FILTER = 'attachment/data-lists';
export const API_SYSTEM_ADMIN_ATTACHMENT_DETAIL = 'attachment/:id';
export const API_SYSTEM_ADMIN_SOW_ORDER_EVENT_SEATS = 'seat/:eventId/sow-event-seats';
export const API_SYSTEM_ADMIN_GET_PRODUCTS_TO_ADD = 'order/:sowOrderId/products-to-add-sow';
export const API_SYSTEM_ADMIN_ADD_ITEMS_TO_SOW = 'order/:sowOrderId/add-items-sow';

// -------- SUBSCRIBER --------
export const API_SUBSCRIBER_ADDRESS = 'address';
export const API_SUBSCRIBER_ADDRESS_DETAIL = 'address/:id';
export const API_SUBSCRIBER_CHECKOUT = 'checkout';
export const API_SUBSCRIBER_PROFILE = 'profile';
export const API_SUBSCRIBER_UPDATE_EMAIL_PRIMARY = 'profile/email-primary';
export const API_SUBSCRIBER_PROFILE_CHANGE_PASSWORD = 'profile/change-password';
export const API_SUBSCRIBER_SET_PHONE = 'user-phone';
export const API_SUBSCRIBER_USER = 'user';
export const API_SUBSCRIBER_USER_DETAIL = 'user/:id';
export const API_SUBSCRIBER_USER_COURSE_SURVEY = 'user/survey/:courseId/:surveyId';
export const API_SUBSCRIBER_USER_COURSE_TEST = 'user/test/:courseId/:testId';
export const API_SUBSCRIBER_USER_LESSON = 'user/lesson';
export const API_SUBSCRIBER_USER_LESSON_DETAIL = 'user/lesson/:id';
export const API_SUBSCRIBER_ORDERS_USER = 'order/orders-user';
export const API_SUBSCRIBER_AWAITING_ORDERS_ITEMS = 'order/awaiting-order-items/:userId';
export const API_USER_CHECK_STRIPE_CONNECTION = 'user/check-stripe-account-connection';
export const API_ASSIGN_EVENT_TO_COURSE = 'user/product/assign-event-to-course';
export const API_ASSIGN_CE_TO_EVENT = 'user/product/assign-ce-to-event';
export const API_ENABLE_TEST_MODE = 'user/enable-test-mode/:id';

export const API_SUBSCRIBER_ORGANIZATION = 'organization';
export const API_SUBSCRIBER_ORGANIZATION_DETAIL = 'organization/:id';
export const API_SUBSCRIBER_ORGANIZATION_DETAIL_PROFILE = 'organization/:id/profile';
export const API_SUBSCRIBER_ORGANIZATION_PRODUCT = 'organization/product/:id';
export const API_SUBSCRIBER_ORGANIZATION_ADDRESS = 'address/organization';
export const API_SUBSCRIBER_ORGANIZATION_ORDER = 'order/organization/:organizationId';
export const API_SUBSCRIBER_ORGANIZATION_CARD = 'organization/:organizationId/card';
export const API_SUBSCRIBER_ORGANIZATION_TRAINING_GROUP_BY_ID = 'training-groups/:id';
export const API_SUBSCRIBER_TRAINING_GROUP = 'training-groups';
export const API_SUBSCRIBER_ORGANIZATION_TRAINING_GROUP = 'training-groups/organization';
export const API_SUBSCRIBER_ORGANIZATION_TRAINING_GROUP_DETAIL = 'training-groups/organization/:organizationId';
export const API_SUBSCRIBER_ORGANIZATION_TRAINING_GROUP_USER = 'training-groups/user/:id';
export const API_SUBSCRIBER_ORGANIZATION_TRAINING_GROUP_USER_CHANGE = 'training-groups/user/change-training-group/:organizationId';
export const API_SUBSCRIBER_ORGANIZATION_TRAINING_GROUP_USER_CREATE = 'training-groups/user/tg-and-tg-user/:organizationId';
export const API_SUBSCRIBER_ORGANIZATION_USER = 'organization-user';
export const API_SUBSCRIBER_ORGANIZATION_USER_UPDATE_BY_ID = 'organization-user/update-org-user/:id';
export const API_SUBSCRIBER_ORGANIZATION_USER_UPDATE = 'organization-user/:organizationId';
export const API_SUBSCRIBER_SEND_CODE_CHANGE_OWNER = 'organization-user/send-code-change-owner';
export const API_SUBSCRIBER_CONFIRM_CHANGE_OWNER = 'organization-user/confirm-change-ownership';
export const API_SUBSCRIBER_ORGANIZATION_USER_DETAIL = 'organization-user/member/:organizationId/:userId';
export const API_SUBSCRIBER_ORGANIZATION_USER_MEMBER = 'organization-user/member/:organizationId';
export const API_SUBSCRIBER_ORGANIZATION_USER_BY_ID = 'organization-user/member/:id';
export const API_SUBSCRIBER_ORGANIZATION_MEMBER_LESSON_STATUS = 'organization-user/member/lesson-status/:organizationId/:userId';
export const API_SUBSCRIBER_ASSIGN_USER_MANAGER = 'organization-user/assign-user-manager-permission';
export const API_SUBSCRIBER_REMOVE_USER_MANAGER_PERMISSION = 'organization-user/remove-user-manager-permission/:id';
export const API_SUBSCRIBER_ORGANIZATION_GET_SEATS_FILTER = 'seat/get-all-seats';
export const API_SUBSCRIBER_ORGANIZATION_GET_BUNDLE_SEATS_FILTER = 'product-bundle-seat/data-lists';
export const API_SUBSCRIBER_LIST_ORGANIZATION_BUNDLE_SEATS = 'product-bundle-seat/organization/:organizationId';
export const API_SUBSCRIBER_ASSIGN_SEATS = 'seat/assign-seats';
export const API_SUBSCRIBER_ASSIGN_SEAT_DETAIL = 'seat/assign-seat/:seatId';
export const API_SUBSCRIBER_ASSIGN_BUNDLE_SEATS = 'product-bundle-seat/assign-seats';
export const API_SUBSCRIBER_REMOVE_ASSIGNED_BUNDLE_SEAT = 'product-bundle-seat/remove-assigned-seat/:id';
export const API_ORGANIZATIONS_CHECK_STRIPE_CONNECTION = 'organization/check-stripe-account-connection/:organizationId';
export const API_SUBSCRIBER_USER_PROFESSIONAL_FIELD = 'user/professional-field';
export const API_SUBSCRIBER_USER_PROFESSIONAL_FIELD_DETAIL = 'user/professional-field/:userId';
export const API_SUBSCRIBER_USER_PROFESSIONAL_FIELD_ORGANIZATION = 'user/professional-field-organization';
export const API_SUBSCRIBER_USER_PROFESSIONAL_FIELD_ORGANIZATION_DETAIL = 'user/professional-field-organization/:userId';
export const API_SUBSCRIBER_USER_PROFESSIONAL_FIELD_LICENSE_DETAIL = 'user/professional-field-license/:userId';

// -------- GUEST AND SUBSCRIBER --------
export const API_GUEST_SUBSCRIBER_PRODUCT = 'products';
export const API_GUEST_SUBSCRIBER_PRODUCT_TYPE = 'product-type';

export const API_GUEST_SUBSCRIBER_CART = 'cart';
export const API_GUEST_SUBSCRIBER_DETAIL_CART = 'cart/:id';
export const API_GUEST_SUBSCRIBER_ADD_CART = 'cart/add';
export const API_GUEST_SUBSCRIBER_UPDATE_CART = 'cart/update';
export const API_GUEST_SUBSCRIBER_DELETE_CART = 'cart/delete';

export const API_GUEST_SEAT_BY_TOKEN = 'seat/accept-your-seats/:token';
export const API_GUEST_UPDATE_STATUS_ACCEPT_SEATS = 'seat/accept-your-seats/:id/';
export const API_GUEST_BUNDLE_SEAT_BY_TOKEN = 'product-bundle-seat/accept-your-bundle-seats/:token';
export const API_GUEST_UPDATE_STATUS_ACCEPT_BUNDLE_SEATS = 'product-bundle-seat/accept-your-bundle-seats/:id/';
export const API_GUEST_SUBSCRIBER_LICENSEE_CLIENT = 'licensee/licensee-client';
export const API_SUBSCRIBER_CREDIT_CARD = 'credit-card/user/:userId';
export const API_SUBSCRIBER_CREDIT_CARD_UPDATE = 'credit-card/user/:userId/:stripeCardId';
export const API_SUBSCRIBER_CREDIT_CARD_ORG = 'credit-card/organization/:organizationId';
export const API_SUBSCRIBER_CREDIT_CARD_UPDATE_ORG = 'credit-card/organization/:organizationId/:stripeCardId';
export const API_SUBSCRIBER_CREDIT_CARD_DELETE = 'credit-card/delete/:id';
export const API_GUEST_SUBSCRIBER_CONTENT_MANAGEMENT = 'content-management';
